import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import reducers from './reducers/index'
import { createLogger } from 'redux-logger'
import STEPS_NAMES_BY_KEY from './utils/stepsNamesByKey';
import { steps } from './shared/static.steps';

const logger = createLogger()

let firstStepEventAlreadySended = false

window.analytic = []

function sendEvents({getState}) {
  return function (next) {
    return function (action) {
      if (getState().stepsState.currentIndex === 1 && !firstStepEventAlreadySended) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'funnel on onboarding',
          'quiz_action': 'quiz start'
        });

        firstStepEventAlreadySended = true;
      }

      let stepsData = getState().stepsState.data;
      let index = getState().stepsState.currentIndex;
      let currentStep = Object.keys(stepsData)[index];

      if (action.type === 'OPEN_LOADER_REQUEST') {
        window.dataLayer.push({
          'event': 'funnel on onboarding',
          'quiz_action': 'quiz end'
        });
      }

      if (stepsData[currentStep] && stepsData[currentStep].value && action.type === 'TO_NEXT_STEP_REQUEST') {
        console.log(currentStep)
        window.dataLayer.push({
          'event': 'onboarding_question',
          'quiz_question': STEPS_NAMES_BY_KEY[currentStep],
          'quiz_answer': stepsData[currentStep].value,
        });
      }

      return next({
        ...action,
      });
    }
  }
}

function stepsActions({getState}) {
  return function (next) {
    return function (action) {
      let totalSteps = Object.keys(steps).length - 1;
      let currentStep = getState().stepsState.currentIndex;
      let toNextStep = action.type === 'TO_NEXT_STEP_REQUEST';
      let userFinishedOnbording = (currentStep === totalSteps) && toNextStep;

      if (userFinishedOnbording) {
        store.dispatch({
          type: "OPEN_LOADER_REQUEST"
        })
      }

      return next({
        ...action,
      });
    }
  }
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

let store = createStore(
  reducers,
  composeEnhancers(applyMiddleware(thunk, logger, sendEvents, stepsActions))
)

export default store